<template>
    <div class="flex flex-col gap-2 rounded-xl border border-gray-200 bg-white p-3 dark:border-default dark:bg-surface-card/70 sm:flex-row sm:items-center sm:justify-between">
        <!-- Results + controls -->
        <div class="w-full min-w-0 text-left text-sm text-gray-700 dark:text-txt-body sm:flex-1">
            <slot />
        </div>

        <div class="flex w-full shrink-0 items-center justify-end gap-2 sm:w-auto">
            <!-- Clear all button (next to Filtre toggle) -->
            <button
                v-if="hasActiveFilters"
                class="inline-flex h-10 items-center gap-1 rounded-full border border-gray-300 px-3 text-sm font-medium text-gray-700 transition-all hover:border-gray-400 hover:dark:border-default hover:bg-gray-50 dark:border-default dark:text-txt-body dark:hover:bg-subtle"
                @click="$emit('reset')"
            >
                <Icon name="heroicons:x-circle" class="size-4" />
                Vymazať
            </button>

            <!-- Filter Toggle (simple style) -->
            <button
                class="inline-flex h-10 items-center gap-2 rounded-full px-4 text-sm font-semibold transition-all"
                :class="showFilters || hasActiveFilters
                    ? 'bg-primary-100 text-primary-800 hover:bg-primary-200 hover:dark:bg-primary-950/40 dark:bg-primary-900/40 dark:text-primary-200'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:dark:bg-subtle dark:bg-subtle dark:text-txt-body'"
                @click="$emit('update:showFilters', !showFilters)"
            >
                <Icon name="heroicons:funnel" class="size-4" />
                <span>Filtre</span>
                <span
                    v-if="filterCount > 0"
                    class="flex size-5 items-center justify-center rounded-full bg-primary-500 text-xs text-white"
                >
                    {{ filterCount }}
                </span>
                <Icon :name="showFilters ? 'heroicons:chevron-up' : 'heroicons:chevron-down'" class="size-4" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    showFilters: boolean
    hasActiveFilters: boolean
    filterCount?: number
}>(), {
    filterCount: 0
})

defineEmits<{
    (e: 'update:showFilters', value: boolean): void
    (e: 'reset'): void
}>()
</script>
